import styled from "styled-components";

export const StiledDropMenu = styled.div`
	position: fixed;
	top: 0%;
	left: 0%;
	width: 100vw;
	height: 100vh;
	padding: 30px 0 0 0;
	background: ${(p) => p.theme.colors.bgColor1};
`;

export const ButtonClosePosition = styled.div`
	position: absolute;
	top: 15px;
	left: 15px;
`;
export const LanguageBarPosition = styled.div`
	position: absolute;
	top: 15px;
	right: 10px;
`;
